import { loginAdmin, logout, getInfo, getCurrentModules, getModulesTree } from '@/api/sys/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { local } from '@/utils'

const user = {
    state: {
        token: getToken(),
        name: '',
        avatar: '',
        modules: null,
        userType: local.getItem('userType') || 10,
        lastStoreId: local.getItem('lastStoreId') || '',
    },

    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token
        },
        SET_NAME: (state, name) => {
            state.name = name
        },
        SET_MODULES: (state, modules) => {
            state.modules = modules
        },
        SET_USERTYPE: (state, userType) => {
            state.userType = userType
            local.setItem('userType', userType)
        },
        SET_LASTSTOREID: (state, lastStoreId) => {
            state.lastStoreId = lastStoreId
            local.setItem('lastStoreId', lastStoreId)
        }
    },

    actions: {
        // 登录
        Login({ commit }, userInfo) {
            const username = userInfo.username.trim()
            const verifyCodeId = userInfo.verifyCodeId.trim()
            const verifyCode = userInfo.verifyCode.trim()

            return new Promise((resolve, reject) => {
                loginAdmin(username, userInfo.password, verifyCodeId, verifyCode).then(response => {
                    const data = response.result;
                    setToken(data.token || data.Token)
                    local.removeItem('visitedViews')
                    commit('SET_TOKEN', data.token || data.Token)
                    const userType = (data.userType !== undefined && data.userType !== null) ? data.userType : data.UserType;
                    if (userType !== undefined && userType !== null) {
                        commit('SET_USERTYPE', userType)
                    }
                    resolve()
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 获取用户信息
        GetInfo({ commit, state }) {
            return new Promise((resolve, reject) => {
                getInfo(state.token).then(response => {
                    const info = response.result || {}
                    const nickName = info.nickName !== undefined ? info.nickName : info.NickName
                    const userType = info.userType !== undefined ? info.userType : info.UserType
                    const lastStoreId = info.lastStoreId !== undefined ? info.lastStoreId : info.LastStoreId
                    commit('SET_NAME', nickName || '')
                    if (userType !== undefined && userType !== null) {
                        commit('SET_USERTYPE', userType)
                    }
                    if (lastStoreId !== undefined && lastStoreId !== null) {
                        commit('SET_LASTSTOREID', lastStoreId)
                    }
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 获取用户模块
        GetModules({ commit, state }) {
            return new Promise((resolve, reject) => {
                getCurrentModules(state.token).then(response => {
                    commit('SET_MODULES', response.result)
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 获取用户模块
        GetModulesTree({ commit, state }) {
            return new Promise((resolve, reject) => {
                if (state.modules != null) {
                    resolve(state.modules)
                    return
                }
                getModulesTree(state.token).then(response => {
                    commit('SET_MODULES', response.result)
                    resolve(response.result)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 登出
        LogOut({ commit, state }) {
            return new Promise((resolve, reject) => {
                logout(state.token).then(() => {
                    commit('SET_TOKEN', '')
                    commit('SET_MODULES', [])
                    commit('SET_USERTYPE', 10)
                    commit('SET_LASTSTOREID', '')
                    removeToken()
                    local.removeItem('visitedViews')
                    local.removeItem('userType')
                    local.removeItem('lastStoreId')
                    resolve()
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 前端 登出
        FedLogOut({ commit }) {
            return new Promise(resolve => {
                commit('SET_TOKEN', '')
                commit('SET_USERTYPE', 10)
                commit('SET_LASTSTOREID', '')
                removeToken()
                local.removeItem('visitedViews')
                local.removeItem('userType')
                local.removeItem('lastStoreId')
                resolve()
            })
        },
        
        // 更新当前门店ID
        UpdateLastStoreId({ commit }, storeId) {
            return new Promise(resolve => {
                commit('SET_LASTSTOREID', storeId)
                resolve()
            })
        }
    }
}

export default user